import ScopeConstants from "constants/ScopeConstants"
import ProjectStatusConstants from "constants/ProjectStatusConstants"

export const ProjectAnyScope = {
    key: ScopeConstants.PROJECT_ANY,
    selector: (state) => state.projectsAny,
    tokenSelector: (state) => state.authentication.token,
    fetchEndpoint: "/api/Project/SearchAny/",
    singleEndpoint: "/api/Project/GetAny/",
    updateEndpoint: "/api/Project/UpdateAny/",
    deleteEndpoint: "/api/Project/DeleteAny/",
    publishEndpoint: "/api/Project/PublishAny/",
    defaultRecord: {
        name: "",
        code: "",
        status: ProjectStatusConstants.DRAFT
    }
}